import React, { useState } from 'react';
import '../styles/Header.css';


const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMenuClosing, setIsMenuClosing] = useState(false);

  const toggleMobileMenu = () => {
    if (isMobileMenuOpen) {
      setIsMenuClosing(true);
      setTimeout(() => {
        setIsMobileMenuOpen(false);
        setIsMenuClosing(false);
      }, 300);
    } else {
      setIsMobileMenuOpen(true);
    }
  };

  return (
    <header id="masthead" itemScope="itemscope" itemType="https://schema.org/WPHeader">
      <p className="main-title bhf-hidden" itemProp="headline">
        <a href="/" title="Industry Max Home" rel="home">Industry Max</a>
      </p>
      
      <div className="header-container">
        <div className="header-inner">
          <div className="header-top">
            <div className="header-top-left">
              <button 
                className={`mobile-hamburger ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
                aria-expanded={isMobileMenuOpen}
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>
            </div>
            <div className="header-top-right">
              <div className="icon-list-item">
                <span className="icon-list-icon">
                  <i className="fas fa-paper-plane"></i>
                </span>
                <span className="icon-list-text">@</span>
              </div>
              <div className="icon-list-item">
                <a href="/coming-soon/" className="icon-list-text">Download Center</a>
              </div>
            </div>
          </div>

          <div className="header-main">
            <div className="header-content">
              <div className="company-logo">
                <a href="/">
                  <img 
                    src={require('../assets/web_logo.png')} 
                    alt="Industry Max Logo" 
                    width="255" 
                    height="50"
                  />
                </a>
              </div>
              
              <nav className="navigation">
                <ul className="nav-menu">
                  <li className="menu-item">
                    <a href="/" className="nav-link">Home</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    <a 
                      href="/#about-title-html" 
                      className="nav-link has-submenu"
                    >
                      About Industry Max <span className="sub-arrow">▼</span>
                    </a>
                    <ul className="sub-menu">
                      <li className="menu-item">
                        <a href="/e-catalog/" className="nav-link">E‑Profile Download</a>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    <a href="/solutions/" className="nav-link has-submenu">Solutions <span className="sub-arrow">▼</span></a>
                    <ul className="sub-menu">
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Fire%20Systems" className="nav-link has-submenu">Fire Systems <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/fire-alarm" className="nav-link">Fire Alarm</a></li>
                          <li className="menu-item"><a href="/solutions/firefighting-system" className="nav-link">Firefighting System</a></li>
                          <li className="menu-item"><a href="/solutions/fire-suppression-system" className="nav-link">Fire Suppression System</a></li>
                          <li className="menu-item"><a href="/solutions/emergency-light-system" className="nav-link">Emergency Light System</a></li>
                          <li className="menu-item"><a href="/solutions/fire-rated-doors" className="nav-link">Fire-Rated Doors</a></li>
                        </ul>
                      </li>
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Communication%20Systems" className="nav-link has-submenu">Communication Systems <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/voip-phone-system" className="nav-link">VOIP Phone System</a></li>
                          <li className="menu-item"><a href="/solutions/iptv-system" className="nav-link">IPTV System</a></li>
                          <li className="menu-item"><a href="/solutions/public-address" className="nav-link">Public Address</a></li>
                          <li className="menu-item"><a href="/solutions/professional-music" className="nav-link">Professional Music</a></li>
                          <li className="menu-item"><a href="/solutions/smatv-system" className="nav-link">SMATV System</a></li>
                          <li className="menu-item"><a href="/solutions/gsm" className="nav-link">GSM</a></li>
                        </ul>
                      </li>
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Power%20Solutions" className="nav-link has-submenu">Power Solutions <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/avr" className="nav-link">AVR</a></li>
                          <li className="menu-item"><a href="/solutions/power-backup-solution" className="nav-link">Power Backup Solution</a></li>
                          <li className="menu-item"><a href="/solutions/solar-system" className="nav-link">Solar System</a></li>
                        </ul>
                      </li>
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Automation%20Solutions" className="nav-link has-submenu">Automation Solutions <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/building-management-system" className="nav-link">Building Management System</a></li>
                          <li className="menu-item"><a href="/solutions/guestroom-management-system" className="nav-link">Guestroom Management System</a></li>
                          <li className="menu-item"><a href="/solutions/smart-home" className="nav-link">Smart Home</a></li>
                          <li className="menu-item"><a href="/solutions/lighting-control" className="nav-link">Lighting Control</a></li>
                          <li className="menu-item"><a href="/solutions/parking-system" className="nav-link">Parking System</a></li>
                        </ul>
                      </li>
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Networking%20Solutions" className="nav-link has-submenu">Networking Solutions <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/gpon-system" className="nav-link">GPON System</a></li>
                          <li className="menu-item"><a href="/solutions/networking-system-internet" className="nav-link">Networking System & Internet</a></li>
                        </ul>
                      </li>
                      
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Security%20Systems" className="nav-link has-submenu">Security Systems <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/cctv-system" className="nav-link">CCTV System</a></li>
                          <li className="menu-item"><a href="/solutions/access-control" className="nav-link">Access Control</a></li>
                        </ul>
                      </li>
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Data%20Centers" className="nav-link has-submenu">Data Centers <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/raised-floor-system" className="nav-link">Raised Floor System</a></li>
                          <li className="menu-item"><a href="/solutions/data-center" className="nav-link">Data Center</a></li>
                          <li className="menu-item"><a href="/solutions/structured-cabling-system" className="nav-link">Structured Cabling System</a></li>
                        </ul>
                      </li>
                      <li className="menu-item menu-item-has-children">
                        <a href="/solutions/?category=Facility%20Management" className="nav-link has-submenu">Facility Management <span className="sub-arrow">▶</span></a>
                        <ul className="sub-menu">
                          <li className="menu-item"><a href="/solutions/nurse-call-system" className="nav-link">Nurse Call System</a></li>
                          <li className="menu-item"><a href="/solutions/master-clock" className="nav-link">Master Clock</a></li>
                        </ul>
                      </li>
                      
                    </ul>
                  </li>
                  
                  <li className="menu-item menu-item-has-children">
                    <a 
                      href="/#products-title-html" 
                      className="nav-link has-submenu"
                    >
                      Products <span className="sub-arrow">▼</span>
                    </a>
                    <ul className="sub-menu">
                      <li className="menu-item">
                        <a href="/allproducts/" className="nav-link">All Products</a>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item">
                    <a 
                      href="/#why-title-html" 
                      className="nav-link"
                    >
                      Services
                    </a>
                  </li>
                  <li className="menu-item">
                    <a 
                      href="/#partners-title-html" 
                      className="nav-link"
                    >
                      Partners
                    </a>
                  </li>
                  <li className="menu-item">
                    <a href="/#news-title-html" className="nav-link">News</a>
                  </li>
                  <li className="menu-item">
                    <a href="/faq/" className="nav-link">Faq</a>
                  </li>
                  <li className="menu-item menu-item-has-children">
                    <a href="/contact-us/" className="nav-link has-submenu">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </nav>
              
            </div>
          </div>
        </div>
      </div>
      
      {(isMobileMenuOpen || isMenuClosing) && (
        <div className={`mobile-menu-overlay ${isMenuClosing ? 'closing' : ''}`} onClick={toggleMobileMenu}>
          <div className={`mobile-menu ${isMenuClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <h3>Industry Max</h3>
              <button 
                className="mobile-menu-close" 
                onClick={toggleMobileMenu}
                aria-label="Close mobile menu"
              >
                ×
              </button>
            </div>
            <nav className="mobile-nav">
              <ul className="mobile-nav-menu">
                <li className="mobile-menu-item">
                  <a href="/" className="mobile-nav-link" onClick={toggleMobileMenu}>Home</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/#about-title-html" className="mobile-nav-link" onClick={toggleMobileMenu}>About Industry Max</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/e-catalog/" className="mobile-nav-link" onClick={toggleMobileMenu}>E‑Profile Download</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/solutions/" className="mobile-nav-link" onClick={toggleMobileMenu}>Solutions</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/#products-title-html" className="mobile-nav-link" onClick={toggleMobileMenu}>Products</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/#why-title-html" className="mobile-nav-link" onClick={toggleMobileMenu}>Services</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/#partners-title-html" className="mobile-nav-link" onClick={toggleMobileMenu}>Partners</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/#news-title-html" className="mobile-nav-link" onClick={toggleMobileMenu}>News</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/faq/" className="mobile-nav-link" onClick={toggleMobileMenu}>FAQ</a>
                </li>
                <li className="mobile-menu-item">
                  <a href="/contact-us/" className="mobile-nav-link" onClick={toggleMobileMenu}>Contact Us</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
